import script from "./NewPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewPassword.vue?vue&type=script&lang=ts&setup=true"

import "./NewPassword.vue?vue&type=style&index=0&id=9cb93a46&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cb93a46"]])

export default __exports__